import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { setToken, clearToken, getToken } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await client.get("/auth/me", { withCredentials: true });
      setAdmin(r.data);
    } catch {
      clearToken();
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    if (!getToken() && typeof document !== "undefined" && !document.cookie.includes("session_token=")) {
      // No token and no session cookie likely — but cookie may be httpOnly so we still try /me
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const r = await client.post("/auth/login", { email, password });
    setToken(r.data.token);
    await checkAuth();
    return true;
  };

  const refreshGoogle = async (data) => {
    // Called by AuthCallback after successful exchange
    if (data?.email) setAdmin({ email: data.email, role: "admin", name: data.name, picture: data.picture, auth: "google" });
    else await checkAuth();
  };

  const logout = async () => {
    try { await client.post("/auth/logout", null, { withCredentials: true }); } catch {}
    clearToken();
    setAdmin(null);
  };

  return (
    <AuthCtx.Provider value={{ admin, loading, login, logout, refreshGoogle, checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
